module.exports = __webpack_public_path__ + "fonts/UX6i4JxQDm3fVTc1CPuwqoX0hVgzZQUfRDuZrPvH3D8.woff2";